import type { Packaging } from "src/api/client-api/packagings/useGetOnePackaging";

export type CompositePackagingCandidate = {
    id: number;
    name: string;
    olapScores?: Packaging["olapScores"];
};

const scoreFormatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });

export const getCandidateScore = (
    candidates: CompositePackagingCandidate[],
    childId: number | undefined,
): string | undefined => {
    const score = Object.values(candidates.find((candidate) => candidate.id === childId)?.olapScores ?? {})[0];
    if (typeof score?.score.value !== "number") {
        return undefined;
    }

    return `${scoreFormatter.format(score.score.value)} ${score.unit}`;
};
